<template>
	<div>
		<div class="wrapper" ma-0>
			<!-- 서브 헤더 --------- start -->
			<v-layout wrap class="mb-2" align-center>
				<v-icon color="#9D9DB7">
					mdi-circle-small
				</v-icon>
				<span class="sub_header">캠페인 관리</span>
			</v-layout>
			<!-- 서브 헤더 ----------- end -->

			<v-layout align-center class="header_search">
				<v-layout class="search_wrap">
					<v-layout>
						<v-flex class="search_select_type ml-4" style="width:300px; max-width:300px;">
							<selectBox :sel="surveySel_project" class="searchSel" @change="search_reservedays()"></selectBox>
						</v-flex>
					</v-layout>

					<!-- 날짜 선택 --------- start -->
					<v-layout justify-end>
						<!-- <v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2' : 'search_date_1'">
							<DatepickerDialog :picker="termStartpicker"></DatepickerDialog>
						</v-flex>
						<span class="mx-1"> ~ </span>
						<v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2 ' : 'search_date_2'">
							<DatepickerDialog :picker="termEndpicker" :allowed_dates="termCustomer"> </DatepickerDialog>
						</v-flex>
						<v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
							<selectBox :sel="filterDate" @change="selectDays" :class="'searchSel'"></selectBox>
						</v-flex> -->
						<!-- 날짜 선택 --------- end -->
						<!-- <v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
							<selectBox :sel="filterTag"  :class="'searchSel'"></selectBox>
						</v-flex> -->
						<!-- 이름 검색 start  -->
						<v-flex md4 sm4 xs12>
							<txtField
								class="search_box_type"
								v-model="search.value"
								:txtField="search"
								@keyup.enter="searchKeyword"
								ref="search_input"
							></txtField>
						</v-flex>

						<v-btn class="search_btn" color="#ff9419" @click="searchKeyword"><v-icon>mdi-magnify</v-icon>조회</v-btn>
						<!-- 이름 검색 end  -->
					</v-layout>
				</v-layout>
			</v-layout>

			<!-- --- 데이터 테이블 -------- start -->
			<v-layout wrap>
				<!-- 테이블 -->
				<v-flex xs12>
					<datatable
						:datatable="table.datatable"
						class="tbl-type01"
						:detailClick="detailClick"
						@pagination="pagination"
						excelRoute="marketingCampaignManagement"
						@codeCopy="codeCopy"
					>
					</datatable>
				</v-flex>
			</v-layout>
			<!-- --- 데이터 테이블 -------- end -->
		</div>

		<v-layout justify-start align-items-center class="left_minus_margin">
			<btn
				:btn="addBtn"
				:class="'small_action_btn'"
				:style="`background-color:${$store.state.PointColor2}`"
				:btn_txt="'신규등록'"
				@click="addButtonClick()"
			></btn>
		</v-layout>

		<!-- 고객데이터 삭제 팝엄 -->
		<sweetAlert :dialog="sweetDialog" @click="delete_active()" />
		<sweetAlert :dialog="sweetDone" />
		<editMarketingCampaignManageDialog
			:recall="recallTable"
			:setdialog="edit_manage_dialog"
			:projectList="surveySel_project.items"
		></editMarketingCampaignManageDialog>
	</div>
</template>

<script>
import { btn, datatable, editMarketingCampaignManageDialog, selectBox, sweetAlert, txtField } from '@/components/index.js'
export default {
	name: 'marketingCampaignManagement',
	components: {
		datatable,
		selectBox,
		txtField,
		sweetAlert,
		btn,
		editMarketingCampaignManageDialog,
	},
	props: {
		nowTabs: Number,
		tabIdx: Number,
	},
	// watch: {
	// 	nowTabs: {
	// 		deep: true,
	// 		async handler() {
	// 			if (this.nowTabs === this.tabIdx) {
	// 				this.recallTable()
	// 			}
	// 		},
	// 	},
	// },
	data() {
		return {
			businessId: '',
			edit_manage_dialog: {
				id: '',
				dialog: false,
				cpn: '',
			},

			// --- 데이터 테이블 데이터 --``
			surveySel_project: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
			},
			table: {
				datatable: {
					headers: [
						{ text: 'No.', value: 'pj_no', width: '5%', sortable: false },
						{ text: '프로젝트 명', value: 'business_title', sortable: false },
						{ text: '캠페인 명', value: 'cpnTitle', sortable: false },
						{ text: '활용DB', value: 'dbTitle', sortable: false },
						{ text: '등록일', value: 'cpnCreated', sortable: false },
						{ text: '시작일', value: 'cpnStart', sortable: false },
						{ text: '종료일', value: 'cpnEnd', sortable: false },
						{ text: '적용DB수량', value: 'dbTotal', width: '9%', sortable: false },
						{ text: '배분수량', value: 'cpnDistribution', width: '9%', sortable: false },
						{ text: '배분 후 잔여량', value: 'dbLeft', width: '9%', sortable: false },
						{
							text: '비고',
							align: 'center',
							value: 'etc_detail',
							width: '260px',
							sortable: false,
						},
					],
					items: [],
					hidedefaultfooter: false,
					noweditting: '',
					// title: x.name,
					onlyAgree: false,
					// inputboxId: x.id,
					total: 0,
					itemPerPage: 10,
					page: 1,
					pageCount: 0,
				},
				filter: [],
				json_fields: {},
			},

			// 날짜/검색 데이터
			filterDate: {
				value: '오늘',
				errorMessage: '',
				hideDetail: true,
				items: ['오늘', '이번 주', '이번 달'],
				outlined: true,
			},

			filterTag: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: ['전체', '캠페인명', '이름'],
				outlined: true,
			},

			searchsel_type: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: ['전체', '이름', '연락처'],
				outlined: true,
			},
			search: {
				placeholder: '캠페인명을 입력해주세요.',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
				value: '',
			},

			termStartpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			termEndpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			addBtn: {
				// 추가 버튼
				dark: true,
				width: 100,
			},

			reservedaysData: {},

			// 검색
			sweetDone: {
				//  삭제 완료
				open: false,
				title: '',
				content: ``,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			sweetDialog: {
				// 삭제 확인 팝업
				open: false,
				title: '고객 정보 삭제',
				content: `선택한 고객 정보를 삭제하시겠습니까?`,
				cancelBtnText: '취소',
				saveBtnText: '삭제',
				buttonType: 'twoBtn',
				modalIcon: 'info',
				item: {},
			},
		}
	},
	async created() {
		await this.reservedays()
		// await this.getTableData()
	},
	computed: {},
	methods: {
		/** 설정하는 모달창에서 성공적으로 데이터를 저장했을시, 데이터를 받아오고나서 다시 부를때 사용
		@author 조재호
		*/
		recallTable() {
			this.getTableData(this.table.datatable)
		},

		/**캠페인데이터에서 서칭 필터를 걸때는 강제로 페이지를 1로 이동시킨후 작업해줌
		@author 조재호
		*/
		async searchKeyword() {
			this.table.datatable.page = 1
			await this.getTableData()
		},

		/**캠페인 데이터랑 마케팅 데이터를 묶어서 데이터로 가져옴 페이지네이션을 위해서
		 * range오브젝트를 따로 가져옴 베이스 데이터로는 table.pagination을 참조
		@param {object} range 범위를 체크하는 오브젝트
		@author 조재호
		*/
		async getTableData(range) {
			this.$store.state.loading = true
			let form = {
				start: range ? (range.page - 1) * range.itemPerPage : 0,
				limit: range ? range.itemPerPage : this.table.datatable.itemPerPage,
			}
			if (this.surveySel_project.value.id !== 'all') {
				form['businessId'] = [this.surveySel_project.value.id]
			} else {
				form['businessId'] = this.surveySel_project.items.map(el => String(el.id))
			}
			if (this.$gf.checkBlank(this.search.value)) {
				form['campaignTitle'] = this.search.value
			}

			await this.$store.dispatch('getMarketingCampaigns', form).then(res => {
				this.$store.state.loading = false
				const data = res.data.getCampaigns.response
				for (let i = 0; i < data.campaigns.length; i++) {
					data.campaigns[i]['pj_no'] = i + 1 + (this.table.datatable.pagination.page - 1) * this.table.datatable.pagination.itemsPerPage
					data.campaigns[i]['dbLeft'] = data.campaigns[i].dbTotal - data.campaigns[i].cpnDistribution
					const marketing_business = this.surveySel_project.items.filter(el => String(el.id) === String(data.campaigns[i].businessId))
					if (marketing_business.length > 0) {
						data.campaigns[i]['business_title'] = marketing_business[0].title
					}
				}

				this.table.datatable.items = data.campaigns
				this.table.datatable.total = data.total
			})

			// 검색 텍스트필드 blur 처리
			this.$refs.search_input.$children[0].$refs.input.blur()
		},

		async search_reservedays() {
			this.search.value = ''
			this.table.datatable.page = 1
			await this.getTableData()
		},

		maskingName(strName) {
			if (strName.length > 2) {
				var originName = strName.split('')
				originName.forEach((name, i) => {
					if (i === 0 || i === originName.length - 1) return
					originName[i] = '*'
				})
				var joinName = originName.join()
				return joinName.replace(/,/g, '')
			} else {
				var pattern = /.$/ // 정규식
				return strName.replace(pattern, '*')
			}
		},
		maskingPhoneNumber(phoneNumber) {
			const values = phoneNumber.split('-')
			if (values.length > 1) {
				values[1] = '*'.repeat(values[1].length - 2) + values[1][values[1].length - 2] + values[1][values[1].length - 1]
			}
			if (values.length > 2) {
				values[2] = '*'.repeat(values[2].length - 2) + values[2][values[1].length - 2] + values[2][values[1].length - 1]
			}
			return values.join('-')
		},

		async reservedays() {
			this.$store.state.loading = true
			await this.$store.dispatch('bizTitle').then(async resData => {
				if (resData.data.bizTitle.businesses.length > 0) {
					resData.data.bizTitle.businesses.unshift({
						code: 'all',
						id: 'all',
						phone: '',
						title: '전체',
					})
					this.surveySel_project.items = resData.data.bizTitle.businesses
					this.surveySel_project.value = resData.data.bizTitle.businesses[0]
					this.businessId = resData.data.bizTitle.businesses[0].id
					this.$store.state.loading = false
				} else {
					this.$store.state.loading = false
				}
			})
		},

		// 셀렉트 박스 선택된 값 테이블 적용
		async setdate() {
			let today = new Date()
			let before = new Date(today.setDate(today.getDate() - 7))
			let after = new Date(today.setDate(today.getDate() + 7))
			this.termStartpicker.date = this.$moment(before).format('YYYY-MM-DD')
			this.termEndpicker.date = this.$moment(after).format('YYYY-MM-DD')
		},

		termCustomer(val) {
			let start = this.$moment(this.termStartpicker.date).format('YYMMDD')
			let startDate = new Date(this.termStartpicker.date)
			let end = new Date(startDate.setDate(startDate.getDate() + 240))
			let endDate = this.$moment(end).format('YYMMDD')
			val = this.$moment(val).format('YYMMDD') < endDate && this.$moment(val).format('YYMMDD') >= start
			return val
		},
		selectDays() {
			let date
			if (this.$moment().format('ddd') === 'Sun') {
				date = 6
			} else if (this.$moment().format('ddd') === 'Mon') {
				date = 0
			} else if (this.$moment().format('ddd') === 'Tue') {
				date = 1
			} else if (this.$moment().format('ddd') === 'Wed') {
				date = 2
			} else if (this.$moment().format('ddd') === 'Thu') {
				date = 3
			} else if (this.$moment().format('ddd') === 'Fri') {
				date = 4
			} else if (this.$moment().format('ddd') === 'Sat') {
				date = 5
			}
			if (this.filterDate.value === '오늘') {
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
				this.termStartpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '어제') {
				this.termStartpicker.date = this.$moment()
					.subtract(1, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '이번 주') {
				this.termStartpicker.date = this.$moment()
					.subtract(date, 'day')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '지난 주') {
				this.termStartpicker.date = this.$moment()
					.subtract(date + 7, 'day')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.subtract(date + 1, 'day')
					.format('YYYY-MM-DD')
			} else if (this.filterDate.value === '최근 7일') {
				this.termStartpicker.date = this.$moment()
					.subtract(7, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '최근 14일') {
				this.termStartpicker.date = this.$moment()
					.subtract(14, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '최근 30일') {
				this.termStartpicker.date = this.$moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '이번 달') {
				this.termStartpicker.date = this.$moment()
					.subtract(Number(this.$moment().format('DD')) - 1, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '지난 달') {
				this.termStartpicker.date = this.$moment()
					.subtract(1, 'm')
					.startOf('month')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.subtract(1, 'm')
					.endOf('month')
					.format('YYYY-MM-DD')
			} else if (this.filterDate.value === '전체') {
				this.termStartpicker.date = ''
				this.termEndpicker.date = ''
			}
		},

		detailClick(item) {
			this.edit_manage_dialog.dialog = true
			this.edit_manage_dialog.id = item.cpnId
			this.edit_manage_dialog.cpn = item
		},

		async pagination(item) {
			if (!this.table.datatable.pagination) {
				this.table.datatable['pagination'] = item
				this.table.datatable.options = item
			}
			if (item.page > this.table.datatable.pagination.page) {
				// 다음 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				this.getTableData(range)
			} else if (item.itemsPerPage !== this.table.datatable.pagination.itemsPerPage) {
				// 한페이지에 보여줄 아이템 개수 변경
				let range = {
					start: 0,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: 1,
				}
				this.getTableData(range)
			} else if (item.page < this.table.datatable.pagination.page) {
				// 이전 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				this.getTableData(range)
			}
			this.table.datatable['pagination'] = { ...item }
		},

		async delete_active() {
			this.sweetDialog.open = false
			this.$store.state.loading = true
		},
		addButtonClick() {
			this.edit_manage_dialog.dialog = true
			this.edit_manage_dialog.id = ''
			this.edit_manage_dialog.cpn = ''
		},
		/**** DB 상담사 로그인용 프로젝트 코드 복사 버튼
 @author 전현균
 */
		async codeCopy(item) {
			try {
				this.$store.state.loading = true

				// API 호출
				const response = await this.$store.dispatch('loginCodes', {
					campaignId: String(item.cpnId),
					loginType: 'nomal',
				})

				if (!response.data.loginCodes?.length) {
					throw new Error('코드를 찾을 수 없습니다.')
				}

				const codeToShare = response.data.loginCodes[0].code

				//  복사기능 주석 처리 ==============================
				// 모던 브라우저 및 iOS/iPadOS 13+ 지원
				// if (navigator.clipboard && window.isSecureContext) {
				// 	await navigator.clipboard.writeText(codeToShare)
				// 	this.showSuccessMessage(codeToShare)
				// 	return
				// }

				// iOS/iPadOS용 대체 방법
				// if (navigator.userAgent.match(/ipad|iphone/i)) {
				// 	this.showSuccessMessage(codeToShare)
				// 	return
				// }

				// 복사기능 없이 바로 팝업 안에서 복사하도록 바로 팝업 열기 ==========
				this.showSuccessMessage(codeToShare)
			} catch (err) {
				this.showErrorMessage(err)
			} finally {
				this.$store.state.loading = false
			}
		},

		// 성공 메시지 표시
		showSuccessMessage(code) {
			this.sweetDone.open = true
			this.sweetDone.title = '코드 복사'
			this.sweetDone.content = `오늘의 코드 : ${code}\nctrl + c로 코드를 복사하세요.`
			this.sweetDone.modalIcon = 'success'
		},

		// 에러 메시지 표시
		showErrorMessage(err) {
			this.sweetDone.open = true
			this.sweetDone.title = '네트워크 에러'
			this.sweetDone.content = '네트워크 에러가 발생했습니다.\n관리자에게 문의해주세요.' + JSON.stringify(err)
			this.sweetDone.modalIcon = 'info'
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	margin: 0px !important;
}
</style>
<style lang="scss">
.surveyChoice {
	font-size: 18px;
	font-weight: bold;
	margin-right: 10px;
}

.surveyTitle {
	font-size: 18px;
	font-weight: bold;
	margin-top: 20px;
}

.filterFlex {
	padding: 20px 20px 58px 0px;
}

.filterBox {
	background: white;
	height: 100%;
	border: 2px solid #e1e1e1;
	border-radius: 5px;
}

.filterHead {
	margin: 0px !important;
	padding: 14px;
	border-bottom: 1.5px solid #e1e1e1;
}

.filterLayout {
	padding: 14.8px;
	// border-bottom: 1.5px solid #e1e1e1;`
}

.checkboxLinebreak {
	line-break: anywhere;
}

.qaLists-dialog {
	opacity: 0;
	width: 100%;
	background-color: white !important;
}

.search_box_type {
	width: auto !important;
	height: 26px !important;
	margin-right: 10px !important;
	padding: 0 10px !important;
	font-size: 13px;
	font-weight: bold;

	.v-btn__content {
		color: #fff;
	}
}

//검색 박스
.search_box_type {
	width: 193px;
	margin-left: 10px;

	div {
		div {
			.v-input__slot {
				min-height: 26px !important;
				height: 26px;
				padding: 0 10px !important;
			}
		}
	}
}

.search_select_type {
	min-height: 26px !important;
	height: 26px !important;
	width: 400px;
	max-width: 400px;

	div {
		div {
			div {
				div {
					.v-input__append-inner {
						margin-top: 1px !important;
					}
				}
			}
		}
	}
}

.customer-management-text {
	font-size: 12px;
	font-weight: bold;
	width: auto;
	color: #204037;
}

.customer-management-btn {
	box-shadow: none;
	border: 1px solid #c5c3d5;
	width: 88px;
	height: 26px !important;
	background-color: #f3f3ff !important;

	.v-btn__content {
		color: #323153;
		font-size: 13px;
	}
}
</style>
